import React, { useEffect, useState } from "react";
import style from "../LerningDetail/LearningDetail.module.css";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { MdMoreVert, MdArrowBack } from "react-icons/md";
import { PiExam } from "react-icons/pi";
import { LuBook } from "react-icons/lu";
import { baseurl } from "../Url";

const SkillsDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { onMenuToggle, sidebarOpen } = useOutletContext() || {};

  const state = location.state || {};
  const Details = state.learning_detail || {};

  const [topicsData, setTopicsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedModule, setExpandedModule] = useState(null);
  const [startPopup, setStartPopup] = useState(false);

  const rawTitle =
    state.title ||
    Details.Name ||
    Details.course_name ||
    Details.CategoryName ||
    Details.category_details ||
    "";
  const title =
    typeof rawTitle === "string" ? rawTitle.split(",")[0].trim() : rawTitle;

  const subCategoryValue = Array.isArray(Details.sub_category_type)
    ? Details.sub_category_type[0] || ""
    : Details.sub_category_type || state.sub_category_type || "";
  const normalizedSubCategory = String(subCategoryValue || "").toLowerCase();

  let primaryActionLabel = "Start Learning";
  if (
    normalizedSubCategory.includes("course") ||
    normalizedSubCategory.includes("skill")
  ) {
    primaryActionLabel = "Master Skill";
  } else if (
    normalizedSubCategory.includes("simulation") ||
    normalizedSubCategory.includes("internship")
  ) {
    primaryActionLabel = "Build Experience";
  } else if (normalizedSubCategory.includes("interview preparation")) {
    primaryActionLabel = "Get Ready";
  } else if (normalizedSubCategory.includes("exam preparation")) {
    primaryActionLabel = "Win Exam";
  }

  const handleExpand = (moduleKey) => {
    setExpandedModule((prev) => (prev === moduleKey ? null : moduleKey));
  };

  const handleHeaderBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const OrgID = localStorage.getItem("ORGID");
    const keyRaw = localStorage.getItem("access-token");
    let token = keyRaw;
    try {
      token = keyRaw ? JSON.parse(keyRaw) : null;
    } catch {
      token = keyRaw;
    }

    const categoryId =
      Details.category_id || Details.id || Details._id || Details.categoryID;

    if (!OrgID || !categoryId) return;

    const fetchTopics = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${baseurl}/topic/get`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({
            org_id: OrgID,
            category_id: String(categoryId),
          }),
        });
        const data = await res.json();
        if (data && data.status && Array.isArray(data.data)) {
          // API already returns an array of modules with nested topics
          setTopicsData(data.data);
        } else {
          setTopicsData([]);
        }
      } catch (err) {
        console.error("Error fetching topics for /skills/detail:", err);
        setTopicsData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
  }, [Details]);

  const handleStartLearning = async () => {
    const USERID = localStorage.getItem("USERID");
    const OrgID = localStorage.getItem("ORGID");
    const ClubID = localStorage.getItem("ClubID");
    const clubIdsArray = ClubID ? ClubID.split(",") : [];

    const categoryId =
      Details.category_id || Details.id || Details._id || Details.categoryID;

    const keyRaw = localStorage.getItem("access-token");
    let token = keyRaw;
    try {
      token = keyRaw ? JSON.parse(keyRaw) : null;
    } catch {
      token = keyRaw;
    }

    let userLearningId = null;

    try {
      setLoading(true);

      // Only attempt save/get when required identifiers exist
      if (USERID && OrgID && categoryId) {
        // 1) Save learning
        const saveRes = await fetch(`${baseurl}/skills/learning/save`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({
            Organization_ID: OrgID,
            Goal: [
              {
                goal: "Skill Learning",
                time_line: "",
                comments: "",
              },
            ],
            Topics: Array.isArray(topicsData) ? topicsData : [],
            Categories: [
              {
                first_level: String(categoryId),
                last_level: String(categoryId),
              },
            ],
            club_id: clubIdsArray,
            user_id: USERID,
          }),
        });
        const saveData = await saveRes.json();
        if (saveData && saveData.status) {
          userLearningId =
            saveData.data?.user_learning_id ||
            saveData.data?.userlearning_id ||
            saveData.user_learning_id ||
            saveData.userlearning_id ||
            saveData.data?.learnings_id ||
            saveData.data?.learning_id ||
            null;

          if (userLearningId) {
            // Persist so /lerning/detail can use it
            localStorage.setItem("newLearningId", String(userLearningId));

            // 2) Call /skills/learning/get with THIS id (backend logs/verification)
            try {
              await fetch(`${baseurl}/skills/learning/get`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  ...(token && { Authorization: `Bearer ${token}` }),
                },
                body: JSON.stringify({
                  user_learning_id: String(userLearningId),
                }),
              });
            } catch (err) {
              console.error("Error calling /skills/learning/get", err);
            }
          }
        } else if (saveData?.data?.learning_id) {
          // Already enrolled: API returns status: false but includes learning_id
          userLearningId = saveData.data.learning_id;
          localStorage.setItem("newLearningId", String(userLearningId));
        } else {
          console.error("Failed to save skills learning", saveData);
        }
      }

      // 3) Redirect to /lerning/detail (always try to go, even if save/get failed)
      navigate("/lerning/detail", {
        state: {
          learning_detail: Details,
          user_learning_id: userLearningId ? String(userLearningId) : undefined,
          peerRole: state.peerRole,
          returnPath: "/skills",
        },
      });
    } catch (err) {
      console.error("Error in handleStartLearning", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={style.skillsDetailRoot}>
      {loading ? null : null}
      <div className={style.header}>
        <div className={`${style.headerLeft} ${style.skillsDetailHeaderLeft}`}>
          <div className={style.skillsDetailHeaderLeading}>
            {!sidebarOpen && typeof onMenuToggle === "function" && (
              <button
                type="button"
                className={style.skillsDetailHeaderMenuBtn}
                onClick={onMenuToggle}
                aria-label="Open menu"
              >
                <MdMoreVert size={22} />
              </button>
            )}
            <button
              type="button"
              className={style.skillsDetailHeaderBackDesktop}
              onClick={handleHeaderBack}
              aria-label="Go back"
            >
              <MdArrowBack size={22} aria-hidden />
            </button>
          </div>
          <div className={style.headerTitle}>
            <h1>Learnings</h1>
            <p className={style.breadcrumb}>Skills / Details</p>
          </div>
          <button
            className={style.headerPrimaryAction}
            onClick={() => setStartPopup(true)}
          >
            {primaryActionLabel}
          </button>
        </div>
      </div>

      <div className={style.LessonDiv}>
        <div className={style.courseHeader}>
          <h2>{title}</h2>
        </div>

        <div className={style.moduleSection}>
          <div className={style.sectionHeader}>
            <h3>Course Modules</h3>
          </div>
          <div className={style.moduleGrid}>
            {topicsData && topicsData.length > 0 ? (
              topicsData.map((module, moduleIndex) => {
                const rawLabel =
                  module.module_name || `Module ${moduleIndex + 1}`;
                const cleanedLabel =
                  typeof rawLabel === "string"
                    ? rawLabel.replace(/^module\s*\d*\s*[:\-]?\s*/i, "").trim()
                    : rawLabel;
                const label = cleanedLabel || `Module ${moduleIndex + 1}`;
                const moduleTopics = Array.isArray(module.topics)
                  ? module.topics
                  : [];
                const moduleKey = module.module_id || module.topic_id || moduleIndex;
                const isExpanded = expandedModule === moduleKey;

                return (
                  <div
                    className={`${style.moduleCard} ${isExpanded ? style.expanded : ""}`}
                    id={moduleKey}
                    key={moduleKey}
                  >
                    <div
                      className={style.moduleHeader}
                      onClick={() => handleExpand(moduleKey)}
                    >
                      <div className={style.moduleTitleBox}>
                        <span className={style.moduleNumber}>
                          Module {moduleIndex + 1}
                        </span>
                        <h4 className={style.moduleName}>{label}</h4>
                      </div>
                      <div className={style.expandIcon}>
                        {isExpanded ? "−" : "+"}
                      </div>
                    </div>

                    {isExpanded && moduleTopics.length > 0 && (
                      <div className={style.topicsContainer}>
                        {moduleTopics.map((topic, index) => {
                          const topicLabel =
                            topic.value ||
                            topic.name ||
                            topic.topic_name ||
                            topic.title ||
                            "";
                          if (!topicLabel) return null;
                          return (
                            <div
                              className={style.topicRow}
                              key={`${moduleIndex}-${index}`}
                            >
                              <div
                                className={style.topicInfo}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setStartPopup(true);
                                }}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.stopPropagation();
                                    setStartPopup(true);
                                  }
                                }}
                              >
                                <div className={style.topicIcon}>
                                  {topic.type === "exam" ? (
                                    <PiExam />
                                  ) : (
                                    <LuBook />
                                  )}
                                </div>
                                <span className={style.topicTitle}>
                                  {topicLabel}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <div className={style.noData}>
                {!loading ? "There is no content to show." : ""}
              </div>
            )}
          </div>
        </div>
      </div>

      {startPopup && (
        <div
          className={style.PopupOverlay}
          onClick={() => setStartPopup(false)}
        >
          <div
            className={style.SubPopup}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={style.subPopTxt}>
              <p>
                Do you want to start learning {title || "Learning"} ?
              </p>
            </div>
            <div style={{ display: "flex", gap: "0.75rem" }}>
              <div style={{ width: "100%" }}>
                <button
                  onClick={() => setStartPopup(false)}
                  style={{
                    width: "100%",
                    background: "white",
                    color: "#0f172a",
                    border: "1px solid #cbd5e1",
                    padding: "1rem 2rem",
                    borderRadius: "0.75rem",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  No
                </button>
              </div>
              <div className={style.subBtn} style={{ width: "100%" }}>
                <button
                  onClick={async () => {
                    setStartPopup(false);
                    await handleStartLearning();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillsDetail;

